/**
 * This file contains the action names and types for owa-mail-store
 */
import FlagType from 'owa-service/lib/contract/FlagType';

export let ApplyConversationFlagStateStoreUpdateActionName = 'applyConverstionFlagStateStoreUpdate';

export interface ApplyConversationFlagStateStoreUpdate {
    (conversationIds: string[], flagType: FlagType, tableViewId: string): void;
}
